import React, { useEffect, useState } from 'react';
import { Card, CardContent, Typography, Radio, RadioGroup, FormControlLabel, FormControl, Chip, Divider, Box } from '@mui/material';
import Upload from '../../Common/Upload';
import CustomButton from '../../../componentsII/Buttons';
import { useSelector } from 'react-redux';
import { DownloadIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import api from '../../../axios/api';
import { showNotification } from '../../../redux/slices/notificationSlice';
import { useDispatch } from 'react-redux';
import CloudinaryFileUploader from '../../Common/CloudinaryFileUploader';
import { useForm, Controller } from 'react-hook-form';

const Category10 = ({ source }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { control, handleSubmit, setValue, watch } = useForm({
    defaultValues: {
      selectedOption: '',
      file: null
    }
  });
  const selectedOption = watch('selectedOption');
  const selectedYear = useSelector((state) => state.user.selectedYear);
  const user = useSelector((state) => state.user.user);
  const [existingData, setExistingData] = useState(null);
  const [expanded, setExpanded] = useState(false);

  const handleBack = (e) => {
    e.preventDefault();
    navigate(-1);
  };

  const forceDownload = (url, filename) => {
    fetch(url)
      .then(response => response.blob())
      .then(blob => {
        const blobUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = blobUrl;
        link.setAttribute('download', filename || 'template.pdf');
        document.body.appendChild(link);
        link.click();
        link.remove();
        URL.revokeObjectURL(blobUrl);
      })
      .catch(error => console.error("Error forcing download:", error));
  };

  const handleDownload = async (templateId, filename = 'Capital Goods', e) => {
    // e.preventDefault();
    try {
      const response = await api.get(`/scope3/downloadScope3Template?start_year=${selectedYear.start_year}&end_year=${selectedYear.end_year}&amount_based=1&source_id=${13}`);
      if (response.data.fileUrl) {
        // Open the file in a new tab or trigger download
        forceDownload(response.data.fileUrl, filename);

        dispatch(showNotification({ message: 'Download successful!', type: 'success' }));
      } else {
        throw new Error("File URL not found in response");
      }
      // const url = window.URL.createObjectURL(new Blob([response.data], { type: response.data.type }));
      // const link = document.createElement('a');
      // link.href = url;
      // link.setAttribute('download', filename || 'template.pdf');
      // document.body.appendChild(link);
      // link.click();
      // link.remove();

      // dispatch(showNotification({ message: 'Download successful!', type: 'success' }));
    } catch (error) {
      dispatch(showNotification({ message: 'Template not found for category', type: 'error' }));
      // dispatch(showNotification({ 'message': error.message, 'type': 'error' }))
      console.error('Error downloading template:', error);
    }
  };

  const fetchExistingData = async () => {
    try {
      const response = await api.get(`/scope3/getScope3CategoryWiseData?company_id=${user.company.id}&year_id=${selectedYear.id}&cat_id=${13}`);
      if (response.data.data && response.data.data.length > 0) {
        const latestData = response.data.data[0];
        setExistingData({
          id: latestData.id,
          dataType: 'amount',
          fileName: latestData.file_name,
          filePath: latestData.file_path,
          send_for_review: latestData.send_for_review
        });

        // Pre-fill form values if existing data exists
        setValue('selectedOption', 'amount');
        setValue('file', {
          name: latestData.file_name,
          path: latestData.file_path
        });
      }
    } catch (error) {
      dispatch(showNotification({
        message: 'Error fetching existing data',
        type: 'error'
      }));
      console.error(error);
    }
  };

  useEffect(() => {
    fetchExistingData();
  }, [user.company.id, selectedYear.id]);

  const onSubmit = async (data) => {
    try {
      // Validate required fields
      if (!data.selectedOption) {
        dispatch(showNotification({
          message: 'Please select a purchase data type',
          type: 'error'
        }));
        return;
      }

      if (!data.file || typeof data.file !== 'object' || data.file == "null" || !data.file.name || data.file.name == "null" || !data.file.path || data.file.path == "null") {
        dispatch(showNotification({
          message: 'Please upload a valid file',
          type: 'error'
        }));
        return;
      }

      // Existing submission logic remains the same
      const formData = new FormData();
      formData.append('company_id', user.company.id);
      formData.append('start_year', selectedYear.start_year);
      formData.append('end_year', selectedYear.end_year);
      formData.append('year_id', selectedYear.id);
      formData.append('amount_based', 1);
      formData.append('quantity_based', 0);
      formData.append('other', 0);
      formData.append('source_id', 13);
      formData.append('file_name', data.file.name);
      formData.append('file_path', data.file.path);
      formData.append('send_for_review', 1);

      // Submit the form
      const response = await api.post('/scope3/saveScope3CategoryWiseData', formData, {
        headers: {
          'Content-Type': 'application/json'
        }
      });

      // Show success notification
      dispatch(showNotification({
        message: 'Data submitted successfully!',
        type: 'success'
      }));

    } catch (error) {
      // Handle submission error
      dispatch(showNotification({
        message: error.response?.data?.message || 'Submission failed',
        type: 'error'
      }));
      console.error('Submission error:', error);
    }
  };

  const handleSave = async (data) => {
    try {
      // Validate required fields
      if (!data.selectedOption) {
        dispatch(showNotification({
          message: 'Please select a purchase data type',
          type: 'error'
        }));
        return;
      }

      if (!data.file || typeof data.file !== 'object' || data.file == "null" || !data.file.name || data.file.name == "null" || !data.file.path || data.file.path == "null") {
        dispatch(showNotification({
          message: 'Please upload a valid file',
          type: 'error'
        }));
        return;
      }

      // Existing submission logic remains the same
      const formData = new FormData();
      formData.append('company_id', user.company.id);
      formData.append('start_year', selectedYear.start_year);
      formData.append('end_year', selectedYear.end_year);
      formData.append('year_id', selectedYear.id);
      formData.append('amount_based', 1);
      formData.append('quantity_based', 0);
      formData.append('other', 0);
      formData.append('source_id', 13);
      formData.append('file_name', data.file.name);
      formData.append('file_path', data.file.path);

      // Submit the form
      const response = await api.post('/scope3/saveScope3CategoryWiseData', formData, {
        headers: {
          'Content-Type': 'application/json'
        }
      });

      // Show success notification
      dispatch(showNotification({
        message: 'Data submitted successfully!',
        type: 'success'
      }));

    } catch (error) {
      // Handle submission error
      dispatch(showNotification({
        message: error.response?.data?.message || 'Submission failed',
        type: 'error'
      }));
      console.error('Submission error:', error);
    }
  };

  const renderQuestion2Content = () => {
    return (
      <>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2, gap: 1 }}>
          <Box sx={{ width: 28, height: 28, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '0.875rem' }}>
            <div className="bg-green-500 text-white p-1 px-1.5 rounded-full">01</div>
          </Box>
          <div className='flex items-center'>
            <Typography variant="h6">
              To proceed, download and complete the Excel template below.<span style={{ color: 'red' }}>*</span>
            </Typography>
          </div>
        </Box>
        <Box sx={{ ml: 4, mt: -2 }}>
          <Typography variant="caption" sx={{ color: 'text.secondary' }}>
            Once completed, upload the file to submit it to your climate professional to review.
          </Typography>
        </Box>
        <Box sx={{ m: 3, display: 'flex', alignItems: 'center' }}>
          <button
            onClick={handleDownload}
            target="_blank"
            className="flex border-2 gap-1 w-[30%] border-gray-500 bg-green-200 p-2 rounded-full items-center justify-center cursor-pointer"
          >
            <DownloadIcon />Download Template
          </button>
          {/* <div className='ml-2 underline text-blue-500 cursor-pointer'>Learn More</div> */}
        </Box>
      </>
    )
    return null;
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <button
        type='button'
        onClick={handleBack}
        className="flex items-center text-gray-600 hover:text-gray-800 text-lg gap-1 border border-gray-900 px-3 py-1 rounded-md hover:bg-green-200"
      >
        <ArrowLeft className="w-6 h-6" /> Back
      </button>
      <div className="max-w-[800px] w-full mx-auto bg-[#F9FAFB]"    >
        <CardContent sx={{ p: 3 }}>
          {/* Header Section */}
          <Box sx={{ mb: 3 }}>
            <Typography variant="h4" component="h2" sx={{ fontWeight: 'bold' }}>
              Downstream Processing of Sold Products
            </Typography>
            <Typography variant="caption" gutterBottom sx={{ pb: 4 }}>
              <div className='flex gap-2 items-center mt-1'>
                scope 3 - Category 10 - <div className='bg-green-200 px-1 rounded-md'>{selectedYear.start_year}</div>
              </div>
            </Typography>
          </Box>

          {/* Expandable Description */}
          <Box sx={{ mb: 2 }}>
            {!expanded ? (
              <>
                <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
                  This category accounts for emissions from the reporting company that sold the intermediate products allocating those emissions in reporting year {selectedYear.start_year}.
                  This includes the scope 1 and scope 2 emissions of downstream value chain partners (e.g., fabricator, assembler, manufacturer) related to processing the intermediate products.
                </Typography>
                <div onClick={() => setExpanded(true)} className='underline text-transform-none mt-1 cursor-pointer text-blue-500'>
                  Show more
                </div>
              </>
            ) : (
              <>
                <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
                  This category accounts for emissions from the reporting company that sold the intermediate products allocating those emissions in reporting year {selectedYear.start_year}.
                  This includes the scope 1 and scope 2 emissions of downstream value chain partners (e.g., fabricator, assembler, manufacturer) related to processing the intermediate products.
                  Intermediate products are products that require further processing, transformation, and inclusion in another product before use e.g., engine, motor, or heating component.
                </Typography>

                <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
                  This activity data is often challenging for organizations to obtain because it is rarely known exactly what happens to an intermediate product once it is sold. Because of this, the only way to calculate emissions from this category in Pro is to obtain absolute scope 1 & 2 emissions data from your clients and attribute the relevant percentage to your scope 3. Each client can use a tool like CMT-Carbiter Pro to measure their emissions.
                </Typography>


                <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
                  The columns in the template simply require you to input the amount of relevant scope 1 & 2, and optionally scope 3, data from your downstream clients. If you want more information or support calculating this category, please reach out to your climate professional.
                </Typography>
                <div onClick={() => setExpanded(false)} className='underline text-transform-none mt-1 cursor-pointer text-blue-500'>
                  Show less
                </div>
              </>
            )}
          </Box>
          {renderQuestion2Content()}
          <Box sx={{ ml: 4 }}>
            <Controller
              name="file"
              control={control}
              render={({ field: { onChange } }) => (
                <CloudinaryFileUploader
                  key={existingData ? existingData.fileName : null}
                  multiple={false}
                  allowedTypes="xlsx,xls"
                  onUploadComplete={(fileResponse) => {
                    // onChange(fileResponse);
                    setValue('file', fileResponse);
                  }}
                  existingFiles={existingData ? [{
                    name: existingData.fileName,
                    path: existingData.filePath,
                    filename: existingData.fileName,
                    size: 0
                  }] : []}
                />
              )}
            />
          </Box>
          {/* <div className="flex justify-end gap-5 items-center mt-5">
          <CustomButton
                click={() => handleSubmit(handleSave)()}
                className="bg-green-600 hover:bg-green-700 text-white underline"
                text="Save"
              />
            <CustomButton
              className="bg-green-600 hover:bg-green-700 text-white"
              text="Submit Data For Review"
              type='submit'
            />
          </div> */}
          <div className="flex justify-end gap-5 items-center mt-5">
            <CustomButton
              click={() => handleSubmit(handleSave)()}
              className={`text-white underline ${existingData?.send_for_review === 1 ? 'bg-gray-400 cursor-not-allowed' : 'bg-green-600 hover:bg-green-700'}`}
              text="Save"
              disabled={existingData?.send_for_review === 1}
            />
            <CustomButton
              className={`text-white ${existingData?.send_for_review === 1 ? 'bg-gray-400 cursor-not-allowed' : 'bg-green-600 hover:bg-green-700'}`}
              text="Submit Data For Review"
              type="submit"
              disabled={existingData?.send_for_review === 1}
            />
          </div>
        </CardContent>
      </div>
    </form>
  );
};

export default Category10;